import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import { updateCurrentSlideThumbnail, duplicateShape, deleteShape, selectShape, selectLastAddedShape, updateShapeRotation, updateStem } from '../../actions/CurrentSlideActions';
import { uiProperties } from '../utils/TransformToolUtils';
import modeType from '../../constants/ModeConstants';
import { hideMenus, changeContextMode, showCroppingMenu, setContextTarget } from '../../actions/MenuActions';
import menuType from '../../constants/MenuType';
import shapeTypes from '../../constants/ShapeConstants';
import locales from '../../locales/LocalesManager';
import configuration from '../../constants/Configuration';
import mouseUtils from '../../components/utils/MouseUtils';
import animationManager from '../utils/AnimationManager';
import groupManager from '../utils/GroupManager';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import selectionManager from '../utils/SelectionManager';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import appParameters from '../utils/AppParameters';
import zoomUtils from '../utils/ZoomUtils';
import platformDetection from '../utils/PlatformDetection';
import textEditorUtils from './textEditorTool/utils/TextEditorUtils';
import mindMapUtils from "../utils/MindMapUtils";

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                // change moods
                this.props.dispatch(changeContextMode(modeType.OBJECT_CONTEXT_MOODS));
                break;
            }

            case 1: {
                //duplicate shape
                selectionManager.currentSlide = undefined;
                this.props.dispatch(duplicateShape(this.props.contextTarget));
                audioEditorUtils.addActionToHistory();
                this.props.dispatch(selectLastAddedShape());
                this.updateThumbnail();
                saveManager.isContentChanged(true);
                break;
            }

            case 2: {
                // delete shape
                this.props.dispatch(deleteShape([this.props.contextTarget.uuid]));
                this.props.dispatch(selectShape(''));
                audioEditorUtils.addActionToHistory();
                this.updateThumbnail();
                saveManager.isContentChanged(true);
                break;
            }

            case 3: {
                // change style
                this.props.dispatch(changeContextMode(modeType.OBJECT_CONTEXT_STYLING));
                break;
            }

            case 4: {
                // text Styling
                if (this.props.contextTarget) {
                    this.props.dispatch(changeContextMode(modeType.OBJECT_TEXT_STYLING));

                    if (!platformDetection.isIOS()) {
                        setTimeout(function () {
                            var element = document.getElementById('firstFocusableObjectForTextStylingMenu');

                            if (element)
                                element.focus();
                        }.bind(this), 30);
                    }
                }
                break;
            }

            case 5: {
                // advanced option
                this.props.dispatch(changeContextMode(modeType.OBJECT_CONTEXT_ADVANCED));
                break;
            }

            case 7: {
                // Animation
                if (animationManager.allowAnimation)
                    animationManager.enterAnimationMode(this.props.contextTarget);
                else
                    return;
                break;
            }

            case 8: {
                // Ungroup
                groupManager.groupUngroup();
                saveManager.isContentChanged(true);
                break;
            }

            case 9: {
                // Go to theme
                mouseUtils.isCanvasAction = true;
                masterUniverseUtils.goToTheme(this.props.contextTarget.theme);
                this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
                return;
            }

            case 10: {
                // Cropping menu
                zoomUtils.updateCroppingInitialPosition = true;
                zoomUtils.croppingTarget = this.props.contextTarget;

                if (zoomUtils.croppingTarget.rotation != 0) {
                    zoomUtils.croppingTargetRotation = zoomUtils.croppingTarget.rotation;
                    this.props.dispatch(updateShapeRotation(zoomUtils.croppingTarget.uuid, 0));
                }

                this.props.dispatch(selectShape(''));
                this.props.dispatch(showCroppingMenu(true));
                break;
            }
            case 11: {
                // Add stem for Complex Speech bubble
                this.props.dispatch(updateStem(this.props.contextTarget.uuid, 'add'));
                break;
            }
            case 12: {
                // Delete stem for Complex Speech bubble
                this.props.dispatch(updateStem(this.props.contextTarget.uuid, 'delete'));
                break;
            }
            case 13: { // Open TextEditor tool and add text focus
                textEditorUtils.openTextEditorTool(this.props.contextTarget);
                break;
            }
            case 14: {
                // Size and position menu
                this.props.dispatch(changeContextMode(modeType.SIZE_AND_POSITION_CONTEXT));
                break;
            }
        }

        this.props.dispatch(hideMenus([menuType.SHAPE_MENU]));
    },
    updateThumbnail() {
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    onKeyDown(e) {
        if (e.keyCode == 27) { // ESCAPE
            if (mouseUtils.activeElement.length > 0) {
                var element = document.getElementById('interactiveElement_' + mouseUtils.activeElement);

                if (element)
                    element.focus();

                this.props.dispatch(setContextTarget(mouseUtils.activeElement, false));
            }
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget)
            return true;
        else
            return false;
    },
    render() {
        let backgroundColor;

        if (this.state.isOver == true) {
            backgroundColor = properties.BROWSER_HOVER_COLOR;
        } else {
            backgroundColor = properties.SLIDE_MENU_COLOR;
        }

        const paddingLeft = 10;

        var buttonStyle = {
            width: this.props.width - paddingLeft,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: paddingLeft,
            backgroundColor: backgroundColor,
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 0,
            margin: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            paddingLeft: 8,
            fontSize: 14,
            cursor: 'default',
            top: 0
        };

        var tabIndexValue;

        if (this.props.index == 7 && !animationManager.allowAnimation) {
            buttonStyle.opacity = 0.3;
            tabIndexValue = '-1';
        }

        var idValue;

        if (this.props.isFirstElement)
            idValue = 'shapeMenuFirstElement';

        return (
            <button id={idValue} aria-label={this.props.text} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} style={buttonStyle} onKeyDown={this.onKeyDown} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i className={this.props.src}></i>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const ShapeMenuContent = React.createClass({
    isTextShape (shapeModel) {
        if (shapeModel.type == shapeTypes.TEXTBOX || shapeModel.type == shapeTypes.TEXTBOXSIMPLE || shapeModel.type == shapeTypes.SPEAK_BUBBLE  || shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shapeModel.type == shapeTypes.SCREAM_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE)
            return true;
        else
            return false;
    },
    isLocked () {
        return this.props.contextTarget.isLocked;
    },
    correctPosition(x, y, width, height) {
        var newX;
        var newY;
        const leftLimit = this.props.scaleProperties.topX;
        const rightLimit = this.props.scaleProperties.topX + this.props.scaleProperties.scale * configuration.CANVAS_WIDTH;
        const topLimit = this.props.scaleProperties.topY;
        const bottomLimit = this.props.scaleProperties.topY + this.props.scaleProperties.scale * configuration.CANVAS_HEIGHT;

        if (x + width > rightLimit)
            newX = rightLimit - width;
        else if (x < leftLimit)
            newX = leftLimit;
        else
            newX = x;

        if (y + height > bottomLimit)
            newY = bottomLimit - height;
        else if (y < topLimit)
            newY = topLimit;
        else
            newY = y;

        return {x: newX, y: newY};
    },
    detectMenuPosition (shapeModel, width, height) {
        var leftPosition;
        var topPosition;
        const scaleProperties = this.props.scaleProperties;
        const scale = this.props.scaleProperties.scale;
        const radius = uiProperties.RADIUS;

        if (shapeModel.type == shapeTypes.LINE || shapeModel.type == shapeTypes.CURVE) {
            const position1 = {left: scaleProperties.topX + shapeModel.x1 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y1 * scale + radius / 2};
            const position2 = {left: scaleProperties.topX + shapeModel.x2 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y2 * scale + radius / 2};
            var position;
            var opositePosition;

            const topLimit = scaleProperties.topY;
            const leftLimit = scaleProperties.topX;
            const rightLimit = leftLimit + configuration.CANVAS_WIDTH * scale;
            const bottomLimit = topLimit + configuration.CANVAS_HEIGHT * scale;

            if (shapeModel.x1 < shapeModel.x2) {
                position =  position2;
                opositePosition = position1;
            } else {
                position =  position1;
                opositePosition = position2;
            }

            if (position.left > rightLimit || position.left < leftLimit || position.top < topLimit || position.top > bottomLimit)
                position = opositePosition;

            leftPosition = position.left;
            topPosition = position.top;
        } else {
            leftPosition = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale;
            topPosition = scaleProperties.topY + shapeModel.y * scale + radius;
        }

        const pos = this.correctPosition(leftPosition, topPosition, width, height);
        return {x: pos.x, y: pos.y};
    },
    getTheme() {
        var theme = this.props.contextTarget.theme;

        if (theme != appParameters.currentTheme)
            return theme;
        else
            return undefined;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.contextTarget != newProps.contextTarget || this.props.isShapeMenuVisible != newProps.isShapeMenuVisible)
            return true;
        else
            return false;
    },
    render() {
        const contextTarget = this.props.contextTarget;

        if (this.props.mode == modeType.PREVIEW || !contextTarget)
            return (<div/>);

        var height = properties.SHAPE_MENU_BUTTON_HEIGHT * 5;
        var theme = this.getTheme();

        if (theme)
            height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;

        height = height + properties.SHAPE_MENU_BUTTON_HEIGHT; // image manipulation button ... SizeAndPositionMenu

        if (contextTarget && ((contextTarget.moods && contextTarget.moods.length > 1) || (this.isTextShape(contextTarget) == true && contextTarget.type != shapeTypes.TEXTBOXSIMPLE)))
            height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;

        if (contextTarget.type == shapeTypes.GROUP)
            height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;

        if (contextTarget.type == shapeTypes.CHARACTER || contextTarget.type == shapeTypes.IMAGE || contextTarget.type == shapeTypes.ELLIPSE || contextTarget.type == shapeTypes.TRIANGLE || contextTarget.type == shapeTypes.STAR || contextTarget.type == shapeTypes.HEART)
            height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;

        if (contextTarget.type == shapeTypes.COMPLEX_SPEAK_BUBBLE) {
            if (contextTarget.cx5 == undefined)
                height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;

            if (contextTarget.cx2 != undefined)
                height = height + properties.SHAPE_MENU_BUTTON_HEIGHT;
        }

        if (contextTarget.isRichText) // for old text shapes was a button for font properties and a button for fill/stroke ... now will be only one for TextEditorTool
            height = height - properties.SHAPE_MENU_BUTTON_HEIGHT;

        let isMindMapType = mindMapUtils.isMindMapType(contextTarget);

        if (isMindMapType) // COPY and ANIMATION options should be available for the mindMap or mindMap nodes
            height = height - 2 * properties.SHAPE_MENU_BUTTON_HEIGHT;

        const width = properties.SHAPE_MENU_WIDTH;

        var leftPosition = 0;
        var topPosition = 0;
        var visibility;

        if (contextTarget && this.props.isShapeMenuVisible == true) {
            visibility = 'block';

            const position = this.detectMenuPosition(contextTarget, width, height);
            leftPosition = position.x;
            topPosition = position.y;
        }
        else
            visibility = 'none';

        if (contextTarget.type === shapeTypes.VIDEO)
            height = properties.SHAPE_MENU_BUTTON_HEIGHT;

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: height,
            top: topPosition,
            left:leftPosition,
            display: visibility,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: properties.MENUS_BORDER_COLOR,
            userSelect: 'none',
            WebkitUserSelect: 'none'
        };

        const lineStyle = {
            position: 'absolute',
            backgroundColor: properties.MENUS_BORDER_COLOR,
            height: 1,
            width: width
        };

        var elements = [];
        var foundFirstElement = false;
        var firstElementValue = false;

        // SizeAndPositionMenu
        firstElementValue = !foundFirstElement ? true : false;
        foundFirstElement = true;
        elements.push(<Button dispatch={this.props.dispatch} isFirstElement={firstElementValue} index={14} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('SizeAndPosition', 'shapeMenu')} src="fa fa-arrows-alt" key={'shapesMenu16'}/>);

        if (contextTarget.isRichText) {
            firstElementValue = !foundFirstElement ? true : false;
            foundFirstElement = true;

            elements.push(<Button dispatch={this.props.dispatch} isFirstElement={firstElementValue} index={13} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('EditText', 'shapeMenu')} src="fa fa-font" key={'shapesMenu13'}/>);
        }

        if (contextTarget && contextTarget.moods && contextTarget.moods.length > 1) {
            firstElementValue = !foundFirstElement ? true : false;
            foundFirstElement = true;

            elements.push(<Button dispatch={this.props.dispatch} isFirstElement={firstElementValue} index={0} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Moods', 'shapeMenu')} src="fa fa-smile-o" key={'shapesMenu0'}/>);
        }

        if (!isMindMapType) {
            elements.push(<Button dispatch={this.props.dispatch} index={1} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Duplicate', 'shapeMenu')} src="fa fa-files-o" key={'shapesMenu1'}/>);
            elements.push(<Button dispatch={this.props.dispatch} index={7} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Animation', 'shapeMenu')} src="fa fa-certificate" key={'shapesMenu7'}/>);
        }

        if (contextTarget.type == shapeTypes.CHARACTER || contextTarget.type == shapeTypes.IMAGE || contextTarget.type == shapeTypes.ELLIPSE || contextTarget.type == shapeTypes.TRIANGLE || contextTarget.type == shapeTypes.STAR || contextTarget.type == shapeTypes.HEART) {
            elements.push(<Button dispatch={this.props.dispatch} index={10} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Masking', 'other')} src="fa fa-crop" key={'shapesMenu10'}/>);
        }

        if (contextTarget.type != shapeTypes.TEXTBOXSIMPLE && !contextTarget.isRichText) // Border/Fill styling
            elements.push(<Button dispatch={this.props.dispatch} index={3} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Styling', 'shapeMenu')} src="fa fa-paint-brush" key={'shapesMenu3'}/>);

        if (this.isTextShape(contextTarget) == true && !contextTarget.isRichText) // font styling for old text shapes
            elements.push(<Button dispatch={this.props.dispatch} index={4} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('TextStyling', 'shapeMenu')} src="fa fa-font" key={'shapesMenu4'}/>);

        if (contextTarget.type == shapeTypes.GROUP)
            elements.push(<Button dispatch={this.props.dispatch} index={8} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Ungroup', 'shapeMenu')} src="fa fa-object-ungroup" key={'shapesMenu8'}/>);

        if (contextTarget.type == shapeTypes.BACKGROUND || contextTarget.type == shapeTypes.CHARACTER || contextTarget.type == shapeTypes.IMAGE) {
            if (theme) {
                elements.push(<Button dispatch={this.props.dispatch} index={9} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Theme', 'other')} src="fa fa-magic" key={'shapesMenu9'}/>);
            }
        }

        elements.push(<Button dispatch={this.props.dispatch} index={5} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Advanced', 'shapeMenu')} src="fa fa-cog" key={'shapesMenu6'}/>);

        if (contextTarget.type == shapeTypes.COMPLEX_SPEAK_BUBBLE) {
            if (contextTarget.cx5 == undefined)
                elements.push(<Button dispatch={this.props.dispatch} index={11} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('AddStem', 'shapeMenu')} src="fa fa-plus" key={'shapesMenu11'}/>);

            if (contextTarget.cx2 != undefined)
                elements.push(<Button dispatch={this.props.dispatch} index={12} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('DeleteStem', 'shapeMenu')} src="fa fa-minus" key={'shapesMenu12'}/>);
        }

        elements.push(<div style={lineStyle} key={'shapesMenu5'}/>);
        elements.push(<Button dispatch={this.props.dispatch} index={2} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Delete', 'shapeMenu')} src="fa fa-trash-o" key={'shapesMenu2'}/>);

        var display = 'none';

        if (this.isLocked() == true)
            display = 'block';

        const disabledAreaStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: width,
            height: properties.SHAPE_MENU_BUTTON_HEIGHT * (elements.length - 3),
            background: 'white',
            opacity: 0.5,
            display: display
        };

        if (contextTarget.type === shapeTypes.VIDEO) {
            elements = [];

            elements.push(<Button dispatch={this.props.dispatch} isFirstElement={true} index={2} width={width} height={properties.SHAPE_MENU_BUTTON_HEIGHT} contextTarget={this.props.contextTarget} text={locales.getCaption('Delete', 'shapeMenu')} src="fa fa-trash-o" key={'shapesMenu2'}/>);
        }

        return (
            <div style={menuStyle}>
                {elements}
                <div style={disabledAreaStyle}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const contextTarget = state.menu.contextTarget;
    const isShapeMenuVisible = state.menu.isShapeMenuVisible;

    return {
        contextTarget,
        isShapeMenuVisible
    };
}

export const ShapeMenu = connect(mapStateToProps)(ShapeMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ShapeMenu.js
 **/